import Ably from 'ably-hubspot-js';
import { AblyRealtimeWrapper } from 'ably-hubspot-js/ably/api-wrappers/AblyRealtimeWrapper';
import { getLogLevel } from 'ably-hubspot-js/ably/operators/getLogLevel';
import { createSentryLogger } from 'ably-hubspot-js/sentry/createSentryLogger';
import { buildAggregateReporter } from 'ably-hubspot-js/metrics/builders/buildAggregateReporter';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getAblyTokenRpc } from '../../__generated__/chirp/com/hubspot/crm/records/realtime/rpc/CrmRecordsRealtimeRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const ablyLogger = createSentryLogger({
  maxLines: 100,
  sentryDataKey: 'ablyLogs'
});
const getReporter = (() => {
  let reporter = null;
  return () => {
    if (reporter) return reporter;
    reporter = buildAggregateReporter();
    reporter.start();
    return reporter;
  };
})();
const createConnectedAblyClient = async () => {
  const realtime = new Ably.Realtime({
    authCallback: (__tokenParams, callback) => {
      rpcClient.call(getAblyTokenRpc, {
        request: {}
      }).then(tokenResponse => {
        callback(null, tokenResponse.token);
      }).catch(err => {
        callback(err, null);
        setTimeout(() => {
          throw err;
        });
      });
    },
    autoConnect: false,
    log: {
      level: getLogLevel(),
      handler: ablyLogger.log
    },
    queryTime: true
  });

  // TODO: At some point, create our own convenience wraper for the Ably client. This one contains some assumptions that make our use case hard to work with.
  const wrapper = new AblyRealtimeWrapper(realtime, getReporter(), () => true);
  await wrapper.connect();
  return wrapper;
};
const getAblyClient = (() => {
  let client = null;
  return async () => {
    if (client) return client;
    client = await createConnectedAblyClient();
    return client;
  };
})();
export default getAblyClient;